export default __webpack_public_path__ + "static/media/uninstallBlinds.5c9c5dcf.png";